import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Phone, CheckCheck } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
const wa = (p) => `https://wa.me/55${p.replace(/\D/g, "").replace(/^55(?=\d{10,11}$)/, "")}`;

export const SiteLeads = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/site-leads").then((r) => setRows(r.data || [])).catch(() => toast.error("Falha ao carregar contatos"));
  useEffect(() => { load(); }, []);
  const toggle = async (l) => {
    await api.patch(`/admin/site-leads/${l.id}`, { status: l.status === "novo" ? "atendido" : "novo" });
    load();
  };
  if (!rows) return null;
  if (!rows.length) return <p className="text-sm text-slate-500 p-4 text-center" data-testid="site-leads-empty">Nenhum contato pelo chat do site ainda.</p>;
  return (
    <div className="space-y-2" data-testid="site-leads-list">
      {rows.map((l) => (
        <div key={l.id} className={`rounded-xl border p-3 bg-white ${l.status === "novo" ? "border-violet-300" : "border-slate-200 opacity-70"}`} data-testid={`site-lead-${l.id}`}>
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <p className="font-black text-slate-900 text-sm">{l.name} <span className="font-semibold text-slate-500">· {l.school}</span></p>
              <p className="text-[12px] text-slate-600">{l.phone} · {fmt(l.created_at)}</p>
              {l.topic && <p className="text-[11px] text-slate-500 mt-1">Perguntou: {l.topic}</p>}
            </div>
            <span className={`shrink-0 text-[10px] font-black uppercase px-2 py-0.5 rounded-full ${l.status === "novo" ? "bg-violet-100 text-violet-700" : "bg-slate-100 text-slate-500"}`}>{l.status}</span>
          </div>
          <div className="mt-2 flex gap-2">
            <a href={wa(l.phone)} target="_blank" rel="noreferrer" data-testid={`site-lead-wa-${l.id}`} className="h-8 px-3 rounded-lg bg-emerald-500 text-white text-[12px] font-bold inline-flex items-center gap-1"><Phone className="w-3.5 h-3.5" /> WhatsApp</a>
            <button type="button" onClick={() => toggle(l)} data-testid={`site-lead-toggle-${l.id}`} className="h-8 px-3 rounded-lg border border-slate-200 text-[12px] font-bold inline-flex items-center gap-1"><CheckCheck className="w-3.5 h-3.5" /> {l.status === "novo" ? "Marcar atendido" : "Reabrir"}</button>
          </div>
        </div>
      ))}
    </div>
  );
};
